import { Component, inject, OnInit } from '@angular/core';
import { ToolbarComponent } from "../toolbar/toolbar.component";
import { SidenavComponent } from "../sidenav/sidenav.component";
import { TranslateService } from '@ngx-translate/core';
import { tap, switchMap, first } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { OktaAuthService } from '../../services/okta-auth.service';
//import { OktaAuthService } from '../../services/okta-auth.service';

@Component({
  selector: 'app-core',
  standalone: true,
  imports: [ToolbarComponent, SidenavComponent],
  templateUrl: './core.component.html',
  styleUrl: './core.component.scss'
})
export class CoreComponent implements OnInit {
  private readonly notificationService = inject(NotificationService);
  private readonly translate = inject(TranslateService);
  public readonly oktaAuthService = inject(OktaAuthService);


  ngOnInit(): void {
    this.notificationService.setDefaultTheme();
    this.configureLanguage();
    this.notificationService.checkForUpdates().pipe(
      tap(sw => console.log(sw.type)),
      switchMap(() => this.notificationService.requestNotifications())
    ).subscribe();
    this.oktaAuthService.authorize().subscribe();
  }


  private configureLanguage(): void {
    this.translate.setDefaultLang('pl-PL'); // fallback lang
    const lang = localStorage.getItem('language') || 'pl-PL'; // set polish as default 
    // this.translate.use(this.translate.getBrowserLang() || "en")
    this.translate.use(lang)
      .pipe(
        first()
      ).subscribe();
  }
}
